import { memo, useContext, useEffect, useState } from "react";

import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  Typography,
} from "@material-ui/core";

import SelectErp from "../../../components/basics/SelectErp";
import TextFieldErp from "../../../components/basics/TextFieldErp";
import {
  StyledModal,
  StyledModalCard,
  StyledModalContent,
  StyledModalFooter,
  StyledModalHeader,
  TypographyStyled,
} from "../styles/DashBoard";

import { Close } from "@material-ui/icons";
import LoadingCheckBox from "../../financeiro/resultadoexercicio/children/LoadingCheckBox";
import { DashBoardContext } from "../contexts/DashBoardContext";
import useDashBoardController from "../controllers/DashBoardController";

function ModalDashBoardFilters() {
  const {
    handleChangeYearPeriod,
    handleChangeTypePeriod,
    handleChangeAnualQuarter,
    handleChangeMonth,
    handleSetCompanies,
    handleCheckCompany,
    handleChangeLoading,
    handleCloseModal,
    clearFilters,
  } = useDashBoardController();

  const [disabledCustomDateField, setDisabledCustomDateField] = useState(true);

  const {
    yearPeriod,
    typePeriodList,
    typePeriod,
    customStartDate,
    setCustomStartDate,
    customEndDate,
    setCustomEndDate,
    showSelectAnualQuarter,
    showSelectMonth,
    anualQuarter,
    anualQuarterList,
    month,
    monthList,
    companies,
    loading,
    isFilterModalOpen,
  } = useContext(DashBoardContext);

  useEffect(() => {
    if (
      companies.length === 0 &&
      !loading.filtro &&
      !!sessionStorage.getItem("empresa_cnpj")
    ) {
      handleChangeLoading("filtro", true);
      handleSetCompanies();
    }
  }, [companies, handleSetCompanies, handleChangeLoading, loading]);

  useEffect(() => {
    setDisabledCustomDateField(typePeriod?.id !== "P");
    if (!typePeriod) {
      setCustomStartDate(null);
      setCustomEndDate(null);
    }
  }, [setCustomEndDate, setCustomStartDate, typePeriod]);

  return (
    <StyledModal
      open={isFilterModalOpen}
      disableEnforceFocus
      onClose={handleCloseModal}
    >
      <StyledModalCard>
        <Grid container>
          <StyledModalHeader item container alignItems="center">
            <Grid item xs>
              <TypographyStyled>Filtros Gerais</TypographyStyled>
            </Grid>
            <Grid item>
              <IconButton size="small" onClick={handleCloseModal}>
                <Close />
              </IconButton>
            </Grid>
          </StyledModalHeader>
          <StyledModalContent item container>
            <Grid item xs={12} container>
              <Grid item xs={12}>
                <Typography variant="subtitle2" color="textSecondary">
                  Empresas:
                </Typography>
              </Grid>
              {loading.filter || !companies.length
                ? Array(8)
                    .fill(<LoadingCheckBox />)
                    .map((loadingSkeleton, index) => (
                      <Grid item xs={3} key={`loading-${index}`}>
                        {loadingSkeleton}
                      </Grid>
                    ))
                : companies?.map((company) => (
                    <Grid item xs={3} key={company.id}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={company.check}
                            onChange={() => {
                              handleCheckCompany(company.id);
                            }}
                          />
                        }
                        label={company.apelido}
                      />
                    </Grid>
                  ))}
            </Grid>

            <Grid item xs={2}>
              <TextFieldErp
                label="Ano"
                type="number"
                value={yearPeriod}
                onChange={(e) => {
                  handleChangeYearPeriod(e.target.value);
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <SelectErp
                label="Período"
                value={typePeriod}
                optionsList={typePeriodList}
                onChange={(value) => {
                  handleChangeTypePeriod(value);
                }}
                descriptionField="label"
              />
            </Grid>
            <Grid item xs={2}>
              {showSelectAnualQuarter && (
                <SelectErp
                  label="Trimestre"
                  value={anualQuarter}
                  optionsList={anualQuarterList}
                  onChange={(value) => {
                    handleChangeAnualQuarter(value);
                  }}
                  descriptionField="label"
                />
              )}
              {showSelectMonth && (
                <SelectErp
                  label="Mês"
                  value={month}
                  optionsList={monthList}
                  onChange={(value) => {
                    handleChangeMonth(value);
                  }}
                  descriptionField="label"
                />
              )}
            </Grid>
            <Grid item xs={2}>
              <TextFieldErp
                label="Data Inicial"
                type="date"
                size="small"
                setValue={setCustomStartDate}
                value={customStartDate}
                disabled={disabledCustomDateField}
              />
            </Grid>
            <Grid item xs={2}>
              <TextFieldErp
                label="Data Final"
                type="date"
                size="small"
                setValue={setCustomEndDate}
                value={customEndDate}
                disabled={disabledCustomDateField}
              />
            </Grid>
          </StyledModalContent>
          <StyledModalFooter item container justifyContent="flex-end">
            <Grid item>
              <Button variant="outlined" color="primary" onClick={clearFilters}>
                Redefinir filtros
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={handleCloseModal}
              >
                Aplicar
              </Button>
            </Grid>
          </StyledModalFooter>
        </Grid>
      </StyledModalCard>
    </StyledModal>
  );
}

export default memo(ModalDashBoardFilters);
